import React, { Component } from 'react'

const defaultMedications = [
  {
    name: 'Effexor-XR (venlafaxine)',
    baseline: '300 mg',
    previous: '225 mg',
    latest: '225 mg',
    change: 'Stayed the same',
  },
  {
    name: 'Lamictal (lamotrigine)',
    baseline: '2000 mg',
    previous: '150 mg',
    latest: '150 mg',
    change: 'Stayed the same',
  },
  {
    name: 'Seroquel (quetiapine)',
    baseline: '100 mg',
    previous: '100 mg',
    latest: '100 mg',
    change: 'Stayed the same',
  },
  /*{
    name: 'Rosuvastatin',
    baseline: '10 mg',
    previous: 'Not listed',
    latest: 'Not listed',
    change: 'Not listed',
  },
  {
    name: 'Amlodipine',
    baseline: '10 mg',
    previous: 'Not listed',
    latest: 'Not listed',
    change: 'Not listed',
  },
  {
    name: 'Varenicline',
    baseline: '2 mg',
    previous: 'Not listed',
    latest: 'Not listed',
    change: 'Not listed',
  },
  {
    name: 'Carvedilol',
    baseline: '25 mg',
    previous: 'Not listed',
    latest: 'Not listed',
    change: 'Not listed',
  },
  {
    name: 'Irbesartan',
    baseline: '300 mg',
    previous: 'Not listed',
    latest: 'Not listed',
    change: 'Not listed',
  },
  {
    name: 'Hydrochlorothazide',
    baseline: '49 mg',
    previous: 'Not listed',
    latest: 'Not listed',
    change: 'Not listed',
  },*/
]

class MedicationComparison extends Component {
  render() {
    const medications =
      this.props.medications || defaultMedications

    const latestDate =
      this.props.latestDate ||
      'August 12, 2026'

    const latestTimepoint =
      this.props.latestTimepoint || 13

    const previousDate =
      this.props.previousDate ||
      'July 13, 2026'

    const previousTimepoint =
      this.props.previousTimepoint || 12

    return (
      <div className="small-12 columns">
        <div className="title6">
          Your Medications
        </div>

        <table>
          <thead>
            <tr>
              <th>Medication</th>
              <th>At Enrollment<br /><span style={styles.dateLabel}>07/16/2025</span></th>
              <th>Previous<br /><span style={styles.dateLabel}>07/13/2026</span></th>
              <th>Now<br /><span style={styles.dateLabel}>08/12/2026</span></th>
            </tr>
          </thead>

          <tbody>
            {medications.map(medication => (
              <tr key={medication.name}>
                <td>{medication.name}</td>
                <td>{medication.baseline}</td>
                <td>{medication.previous}</td>
                <td>
                  <strong>
                    {medication.latest}
                  </strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  dateLabel: {
    fontSize: 11,
    fontWeight: 400,
    color: '#607d8b',
  },
}

export default MedicationComparison
